import { AccessTimeFilled } from '@mui/icons-material';
import { Grid, IconButton, ThemeProvider } from '@mui/material';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { Colors } from 'library/theme';
import React, { useState } from 'react';
import { newMuiTheme } from 'theme';
// eslint-disable-next-line import/named
import { TimePicker as MuiTimePicker, TimePickerProps } from '@mui/x-date-pickers/TimePicker';
import moment from 'moment-timezone';
import { Text } from 'library/components/text';

export default function TimePicker(props: TimePickerProps<moment.Moment>) {
    const timeIsNoon = props.value?.hour() === 12 && props.value?.minute() === 0;
    const timeIsMidnight = props.value?.hour() === 0 && props.value?.minute() === 0;
    const [isOpen, setIsOpen] = useState(false);

    return (
        <ThemeProvider theme={newMuiTheme}>
            <LocalizationProvider dateAdapter={AdapterMoment} dateLibInstance={moment}>
                <MuiTimePicker
                    sx={{ width: '100%', '& .MuiInputLabel-root': { color: Colors.primary } }}
                    slotProps={{
                        textField: {
                            variant: 'standard',
                            InputProps: {
                                sx: { fontFamily: 'Outfit', fontSize: 16, color: Colors.primary },
                                endAdornment: (
                                    <Grid container direction="row" alignItems="center" justifyContent="space-between">
                                        <Text variant="body2" color={Colors.accent}>
                                            {timeIsNoon ? '(Noon)' : timeIsMidnight ? '(Midnight)' : ''}
                                        </Text>
                                        <IconButton onClick={() => setIsOpen(!isOpen)}>
                                            <AccessTimeFilled sx={{ color: Colors.primary }} />
                                        </IconButton>
                                    </Grid>
                                ),
                            },
                        },
                        openPickerButton: { sx: { display: 'none' } },
                    }}
                    open={isOpen}
                    onOpen={() => setIsOpen(true)}
                    onClose={() => setIsOpen(false)}
                    {...props}
                />
            </LocalizationProvider>
        </ThemeProvider>
    );
}
